export var Size = /*#__PURE__*/ function(Size) {
    Size["s"] = "s";
    Size["m"] = "m";
    return Size;
}({});
